module.exports = __webpack_public_path__ + "media/08 verge.be3edfb0.mp3";